//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'
import MyCheckboxGroup from '@/components/checkbox-group/CheckboxGroup.vue'
import MyCheckBox from '@/components/checkbox/CheckBox'
import Pie from '@/components/pie/Pie.vue'
import vote from '@/mixins/vote'
import downloadImgs from '@/mixins/downloadImgs'
export default {
  mixins: [vote, downloadImgs],
  data() {
    return {
      currentValue: [],
      rule: {
        custom: {
          imageMultipleValue: {
            required: () => '请选择一个选项',
          },
        },
      },
    }
  },
  props: {
    question: {
      type: Object,
      default() {
        return {}
      },
    },
    index: {
      type: Number,
    },
    readonly: {
      type: Boolean,
    },
    showScore: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    MyCheckboxGroup,
    MyCheckBox,
    Pie,
  },
  created() {
    // 设置投票， 在 mixins 中
    this.mountedVote()
  },
  mounted() {
    this.question.options.forEach(item => {
			this.downFile(item);
		});
    this.$validator.localize('zh_CN', this.rule)
    //已答的题挂上答案
    if (this.question.v_answer) {
      this.currentValue = this.question.v_answer.currentValue
    }
  },
  computed: {
    ...mapGetters(['questionnaireList']),
  },
  watch: {
    currentValue(n) {
      const param = {
        index: this.index,
        v_answered: !!n.length,
      }
      let v_answer = {}
      // 设置当前题目已答
      this.$store.commit('setQuestionAnswered', param)
      if (!param.v_answered) {
        this.$store.commit('setQusstionUserAnswer', {
          index: this.index,
          v_answer,
        })
        // 取消回调
        this.$emit('onSelectCancel')
        return
      }
      v_answer = this.getValue()
      console.log(v_answer)
      //挂本道题用户答案
      this.$store.commit('setQusstionUserAnswer', {
        index: this.index,
        v_answer,
      })
      //把当前选中的选项传给父组件判断子题是否显示
      this.$emit('onSelectChange')
    },
  },
  methods: {
    disabledClick($event, item) {
      new this.$Toast({
        text: `最多只能选择${this.question.selectRangeMax}项`,
        time: 1500,
        position: 'top',
        distance: '50%',
      })
    },
    getValue() {
      const options = []
      this.currentValue.forEach((currentId) => {
        let checkedOption = this.question.options.find((item) => {
          return item.tenantId == currentId
        })
        options.push({
          tenantId: checkedOption.tenantId,
        })
      })
      return {
        tenantId: this.question.tenantId,
        type: 'image_multiple',
        options: options,
        currentValue: this.currentValue,
      }
    },
    getDegree(percent) {
      var str = percent.replace('%', '')
      return (str / 100) * 360
    },
    getCheckboxValidate(question) {
      var rules = []
      if (question.required) {
        rules.push('required')
      }
      if (question.selectRangeMin) {
        rules.push(
          `selectRangeMin:${question.selectRangeMin},${question.selectRangeMax}`
        )
      }
      if (question.selectRangeMax) {
        rules.push(
          `selectRangeMax:${question.selectRangeMin},${question.selectRangeMax}`
        )
      }
      console.log(rules.join('|'))
      return rules.join('|')
    },
    validate() {
      return this.$validator.validateAll()
    },
    // 下载文件
		downFile(item) {
			const arr = item.src.split("fileId=");
			this.ssdpRequestDtgw1({
        code: 'survey_download',
        headers: {
          's-crc-tpl-code': 'EMAP_FILE_DOWN',
          'content-type':'application/json',
        },
        params: {
          fileId: arr[1]
        },
        responseType: "blob",
        isUpload: false,
      })
      .then((res) => {
        const blobUrl = URL.createObjectURL(res.data);
        this.$set(item, "blobUrl", blobUrl);
      });
		}
  },
}
